"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceCollection = void 0;
var dispose_tree_1 = require("@tencent/dispose-tree");
var descriptors_1 = require("./descriptors");
var typing_1 = require("./typing");
var service_identifier_1 = require("./service-identifier");
var key_mapping_1 = require("./key-mapping");
var error_messages_1 = require("../constants/error-messages");
/**
 * DI框架的核心容器
 */
var ServiceCollection = /** @class */ (function () {
    function ServiceCollection() {
        var e_1, _a;
        var entries = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            entries[_i] = arguments[_i];
        }
        // 保存模块的ID和Holder的容器
        this.innerEntries = new Map();
        this.keyMapping = new key_mapping_1.KeyMapping();
        try {
            for (var entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
                var _b = __read(entries_1_1.value, 2), id = _b[0], service = _b[1];
                this.set(id, service);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    /**
     * 设置id对应的service,多次设置时根据一定的策略覆盖
     * @param id
     * @param instanceOrDescriptor
     * @returns
     */
    ServiceCollection.prototype.set = function (id, instanceOrDescriptor) {
        var key = this.keyMapping.generateServiceKey(id, instanceOrDescriptor);
        var holder = this.innerEntries.get(key);
        // holder为空时新建Holder
        if (!holder) {
            this.createNewServiceHolder(key, instanceOrDescriptor);
            return;
        }
        if (instanceOrDescriptor instanceof descriptors_1.SyncDescriptor) {
            // 根据一定的策略进行override
            this.overrideExistServiceHolder(id, holder, instanceOrDescriptor);
        }
        else {
            // holder存在时设置instance
            this.setHolderInstance(key, holder, instanceOrDescriptor);
        }
    };
    /**
     * 设置id对应的service,多次设置时会绑定多个service
     * @param id
     * @param instanceOrDescriptor
     */
    ServiceCollection.prototype.setMulti = function (id, instanceOrDescriptor) {
        var key = this.keyMapping.generateServiceKey(id, instanceOrDescriptor, true);
        var holder = this.innerEntries.get(key);
        // holder为空时新建Holder
        if (!holder) {
            var newHolder = this.createNewHolderByCondition(instanceOrDescriptor);
            this.innerEntries.set(key, newHolder);
        }
    };
    /**
     * 判断是有对应id的binding
     * @param id
     * @returns
     */
    ServiceCollection.prototype.has = function (id) {
        var _this = this;
        var keys = this.keyMapping.getMapping(id);
        return !!keys.find(function (key) { return _this.innerEntries.has(key); });
    };
    /**
     * @deprecated The method should not be used
     */
    ServiceCollection.prototype.get = function (id) {
        var keys = this.keyMapping.getMapping(id);
        if (keys.length === 0) {
            return undefined;
        }
        if (keys.length > 1) {
            // eslint-disable-next-line new-cap
            throw new Error(error_messages_1.AMBIGUOUS_MATCH_SERVICE(service_identifier_1.getIdentifierName(id)));
        }
        var holder = this.innerEntries.get(keys[0]);
        return (holder === null || holder === void 0 ? void 0 : holder.instance) || (holder === null || holder === void 0 ? void 0 : holder.descriptor) || undefined;
    };
    /**
     * 获取一个query对应的所有holder
     * @param query
     * @param filterCallback
     * @returns
     */
    ServiceCollection.prototype.getAllHolder = function (query, filterCallback) {
        var _this = this;
        var keys = this.keyMapping.getMapping(query.serviceIdentifier);
        var holders = [];
        keys.forEach(function (key) {
            var holder = _this.innerEntries.get(key);
            if (holder) {
                holders === null || holders === void 0 ? void 0 : holders.push(holder);
            }
        });
        if (filterCallback) {
            return holders === null || holders === void 0 ? void 0 : holders.filter(function (holder, idx) { return filterCallback(holder, idx); });
        }
        return holders.length > 0 ? holders : undefined;
    };
    /**
     * 获取一个query对应的唯一holder, 但存在多个holder时抛出异常
     * @param query
     * @returns
     */
    ServiceCollection.prototype.getHolder = function (query) {
        var keys = this.keyMapping.getMapping(query.serviceIdentifier);
        if (keys.length === 0) {
            return undefined;
        }
        if (keys.length > 1) {
            // eslint-disable-next-line new-cap
            throw new Error(error_messages_1.AMBIGUOUS_MATCH_SERVICE(service_identifier_1.getIdentifierName(query.serviceIdentifier)));
        }
        var holder = this.innerEntries.get(keys[0]);
        return holder;
    };
    ServiceCollection.prototype.getMapping = function () {
        return this.keyMapping;
    };
    /**
    * 清理容器中的实例
    * @param shouldDispose
    * @param shouldReset
    * @param shouldDelete
    * @param trace
    */
    ServiceCollection.prototype.teardown = function (shouldDispose, shouldReset, shouldDelete, trace) {
        var _this = this;
        // 清理容器中的对象实例
        this.innerEntries.forEach(function (holder, key) {
            var instance = holder.instance, descriptor = holder.descriptor;
            if (shouldDispose === null || shouldDispose === void 0 ? void 0 : shouldDispose(instance)) {
                dispose_tree_1.tryToDispose(instance, trace === null || trace === void 0 ? void 0 : trace.branch(service_identifier_1.getIdentifierName(key)));
            }
            if (descriptor && instance) {
                if (shouldReset === null || shouldReset === void 0 ? void 0 : shouldReset(instance)) {
                    holder.instance = null;
                }
            }
            if (!descriptor && instance) {
                if (shouldDelete === null || shouldDelete === void 0 ? void 0 : shouldDelete(instance)) {
                    _this.innerEntries.delete(key);
                    _this.keyMapping.deleteMapping(key);
                }
            }
        });
    };
    ServiceCollection.prototype.createNewServiceHolder = function (serviceKey, instanceOrDescriptor) {
        // 容器中可能是实例，也可能是SyncDescriptor
        var holder = this.createNewHolderByCondition(instanceOrDescriptor);
        this.innerEntries.set(serviceKey, holder);
    };
    ServiceCollection.prototype.overrideExistServiceHolder = function (identifier, holder, descriptor) {
        var _a, _b, _c;
        // supportsOverride模式下才支持覆盖
        if ((_a = holder.descriptor) === null || _a === void 0 ? void 0 : _a.supportsOverride) {
            // 生成新的key
            var newServiceKey = this.keyMapping.generateServiceKey(identifier, descriptor);
            var newHolder = this.createHolderInstance(null, descriptor);
            this.innerEntries.set(newServiceKey, newHolder);
        }
        else if (!holder.instance) {
            if (!((_b = holder.descriptor) === null || _b === void 0 ? void 0 : _b.isEqualWith(descriptor))) {
                // 多个key绑定到同一个descriptor的情况下无效warning
                // 同一个key绑定到多个descriptor的情况下需要warning
                // eslint-disable-next-line new-cap
                console.warn(error_messages_1.OVERRIDE_WARNING(service_identifier_1.getIdentifierName(identifier)));
            }
        }
        else {
            // 原有holder有实例时，更新构造函数，抛出异常
            // eslint-disable-next-line new-cap
            throw new Error(error_messages_1.UPDATE_HOLDER_INSTANCE(service_identifier_1.getIdentifierName(identifier), (_c = holder.descriptor) === null || _c === void 0 ? void 0 : _c.ctor.name));
        }
    };
    ServiceCollection.prototype.setHolderInstance = function (serviceKey, holder, instance) {
        dispose_tree_1.tryToMarkDispose(instance);
        // 可能覆盖原holder里的实例
        holder.instance = instance;
        this.innerEntries.set(serviceKey, holder);
    };
    ServiceCollection.prototype.createNewHolderByCondition = function (instanceOrDescriptor) {
        // 容器中可能是实例，也可能是SyncDescriptor
        if (instanceOrDescriptor instanceof descriptors_1.SyncDescriptor) {
            var holder_1 = this.createHolderInstance(null, instanceOrDescriptor);
            return holder_1;
        }
        // 放入的实例需要track
        dispose_tree_1.tryToMarkDispose(instanceOrDescriptor);
        var holder = this.createHolderInstance(instanceOrDescriptor, null);
        return holder;
    };
    ServiceCollection.prototype.createHolderInstance = function (instance, descriptor) {
        var holder = new typing_1.ServiceHolder(instance, descriptor);
        return holder;
    };
    return ServiceCollection;
}());
exports.ServiceCollection = ServiceCollection;
//# sourceMappingURL=service-collection.js.map